export default "/assets/images/mila-filters.webp?05e93bdff5e88e43c8d3d554666b59f9";